export const ImxRewards: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="17"
    viewBox="0 0 19 17"
    {...props}
  >
    <title>Imx Rewards</title>
    <path d="M7.81325 0.544922L5.41158 5.35742H0.68158L3.08325 0.544922H7.81325Z" />
    <path d="M9.64665 0.544922H9.35332L6.94248 5.35742H12.0575L9.64665 0.544922Z" />
    <path d="M13.5882 5.35742H18.3182L15.9165 0.544922H11.1865L13.5882 5.35742Z" />
    <path d="M10.1875 6.73242H18.0984L10.1875 16.2199V6.73242Z" />
    <path d="M8.8124 16.2199V6.73242H0.901571L8.8124 16.2199Z" />
  </svg>
);
